module.exports = __webpack_public_path__ + "static/media/Wayne.374a66de.png";